import React, { Component } from 'react';
import { routes } from 'constants/config';
import { Icon } from 'ui';
import request from 'utils/request_ajax';

class GradePendingNotice extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      loading: true,
    };
  }

  fetchPendingCount = () => {
    request.get(routes.GRADES.DISPLAY_GRADES_PENDING).then(gradeData => {
      this.setState({ data: gradeData, loading: false });
    });
  };

  componentDidMount() {
    this.fetchPendingCount();
    global.pubsub.subscribe(
      'grades:update_pending_count',
      this.fetchPendingCount,
    );
  }

  componentWillUnmount() {
    global.pubsub.unsubscribe(
      'grades:update_pending_count',
      this.fetchPendingCount,
    );
  }

  displayGradePendingCount = () => {
    const gradePendingCount = this.state.data.learner_grade_pending_count;

    if (this.state.data.over_limit) {
      return t('grades.items_to_grade_over_threshold', {
        count: gradePendingCount,
      });
    }
    return t('grades.items_to_grade', {
      count: gradePendingCount,
    });
  };

  render() {
    const { loading, data } = this.state;

    if (loading || data.learner_grade_pending_count === 0) return null;
    return (
      <span className="GradePendingNotice">
        <a href={routes.GRADES.INDEX()} className="navbar-badge">
          <Icon name="edit" className="mr-4" />
          {this.displayGradePendingCount()}
        </a>
      </span>
    );
  }
}

export default GradePendingNotice;
